import React from 'react';
import BaseIcon from './BaseIcon';

class LockWithBorderSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 314 314"
        height={height}
        width={width}
      >
        <rect
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          x="114.05"
          y="140.89"
          width="85.9"
          height="68"
          rx="2"
          ry="2"
        />
        <circle
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          cx="157"
          cy="167.74"
          r="5.37"
        />
        <line
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          x1="157"
          y1="173.11"
          x2="157"
          y2="187.42"
        />
        <line
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          x1="182.05"
          y1="130.16"
          x2="182.05"
          y2="140.89"
        />
        <line
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          x1="131.95"
          y1="140.89"
          x2="131.95"
          y2="130.16"
        />
        <path
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          d="M392-88.34a25.05,25.05,0,0,1,25.05-25.05,25.05,25.05,0,0,1,25.05,25.05"
          transform="translate(-260.08 218.5)"
        />
        <path
          strokeWidth="13px"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          d="M567.58-61.5A150.5,150.5,0,0,1,417.08,89,150.49,150.49,0,0,1,266.58-61.5,150.49,150.49,0,0,1,417.08-212,150.5,150.5,0,0,1,567.58-61.5Z"
          transform="translate(-260.08 218.5)"
        />
      </svg>
    );
  }
}

export default LockWithBorderSVG;
